(() => {
  document.addEventListener('change', (event) => {
    if (event.target.matches('#GRSortBy')) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.assign(url.toString());
    }
  });
})();
